export const stats = [
  { value: '+120', label: 'Sessions Ready' },
  { value: '+2,000', label: 'Coaches Satisfied' },
  { value: '3,500+', label: 'Hours Saved' },
  { value: '99%', label: 'Would Recommend' },
]

export const differenceStats = [
  { value: '+120', label: 'Ready-to-Coach Sessions' },
  { value: '6', label: 'Complete Digital Volumes' },
  { value: '100%', label: 'Instantly Downloadable' },
]

export const beforeItems = [
  'Hours searching YouTube for last-minute drills',
  'Repetitive and boring exercises for the kids',
  'No clear progression from U6 to U16',
  'Not knowing how to manage difficult parents',
  'Unmotivated players who stop improving',
]

export const afterItems = [
  "5-minute review and you're set",
  'Visual and engaging tactical drills',
  'Age-specific development integrated',
  'Evaluation tools and tactics boards ready',
  'Players mastering skills with confidence',
]

export const recognizeItems = [
  {
    emoji: '😰',
    text: 'Arriving at the pitch without knowing exactly how to explain a drill',
  },
  {
    emoji: '⏱️',
    text: 'Spending your entire Sunday planning what should take minutes',
  },
  {
    emoji: '🤷',
    text: 'Struggling to find football worksheets that are actually high-quality and visual',
  },
  {
    emoji: '📋',
    text: 'No clear way to track player progress throughout the season',
  },
  {
    emoji: '😴',
    text: "Players falling behind because the sessions aren't connected",
  },
  {
    emoji: '🌙',
    text: "Still not ready for Monday's training by Sunday night",
  },
]

export const packItems = [
  {
    emoji: '⚽',
    title: '6 Development Volumes (U6 to U16+)',
    text: 'A full professional pathway for every age group.',
  },
  {
    emoji: '🧤',
    title: 'Specialist GK & Specialist Training',
    text: 'Specific sessions for goalkeepers and key roles.',
  },
  {
    emoji: '✏️',
    title: 'Step-by-Step Session Cards',
    text: 'Ready to follow and coach in seconds.',
  },
  {
    emoji: '📐',
    title: 'Visual Tactical Diagrams',
    text: 'High-quality graphics ready to show on your tablet.',
  },
  {
    emoji: '📊',
    title: 'Player Evaluation System',
    text: 'Complete tools to track and measure every player.',
  },
  {
    emoji: '📋',
    title: 'Full Season Planners',
    text: 'Your 52-week roadmap already solved.',
  },
]

export const instantItems = [
  'The 6 complete digital volumes (U6 to U16+ Series)',
  'Drills, tactical systems, and sessions by level',
  'Step-by-step visual guides for every football concept',
  'Coaching scripts that tell you exactly what to say',
  'Parent Communication Kit for a stress-free season',
]

export const bonuses = [
  {
    title: 'The 10-Minute Football Ready Setup Guide',
    was: '$19',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/e1a893ed-53c3-4bce-89e8-23ea25157c6d.jpg',
  },
  {
    title: 'The Full Season 52-Week Planner',
    was: '$27',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/feea4228-e711-4476-a76a-0bc08d40e849.jpg',
  },
  {
    title: 'The Parent Communication & Meeting Kit',
    was: '$36',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/34481b11-936a-4943-9582-b9fda8996e58.jpg',
  },
  {
    title: 'The Match-Day Tactics Board & Game States',
    was: '$47',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/cde5c2b3-91b7-4d39-9500-bd2e91b070e3.jpg',
  },
  {
    title: 'The Football IQ Quiz & Activity Book',
    was: '$19',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/04dcb973-2d9e-4d26-a7d1-81ae8a8aa17f.jpg',
  },
]

export const offerRows = [
  { label: 'Football Ready Pack (6 Digital Volumes)', value: '$77' },
  { label: '5 Exclusive Bonuses', value: '$135' },
]

export const testimonials = [
  {
    quote:
      'I have my Sundays back. The progression from U6 to U16 is exactly what I needed for my club.',
    name: 'Mark S.',
    location: 'UK 🇬🇧',
  },
  {
    quote:
      'The visual diagrams make a huge difference for the kids. They finally understand where to move.',
    name: 'David R.',
    location: 'USA 🇺🇸',
  },
  {
    quote:
      'The Parent Communication kit alone saved my season. No more WhatsApp drama. Worth every penny.',
    name: 'James K.',
    location: 'Australia 🇦🇺',
  },
]

export const faqs = [
  {
    q: 'How do I receive the material?',
    a: 'Instant email download right after your purchase.',
  },
  {
    q: "Does this work if I'm a beginner coach?",
    a: "Yes, it's designed to be plug-and-play.",
  },
  {
    q: 'What age levels does this cover?',
    a: 'U6 all the way to U16 and Seniors.',
  },
  {
    q: 'Are the bonuses included in the price?',
    a: 'Yes, today only.',
  },
  {
    q: 'What file format are the volumes in?',
    a: 'High-quality PDF / visual digital files.',
  },
  {
    q: 'Do I have to pay monthly?',
    a: 'No. One-time payment only.',
  },
]
